import { useCallback, useEffect } from "react";
import type {
  IOptimizationConfig,
  IOptimizationConfigCallBack,
  OptimizationTypeEnum,
  RangeWithStepOrNumber,
  IRoadwayConfig,
  ILuminaireLayoutConfig,
} from "types";
import { getURL, setObjectURL, setFromURLObject } from "utils/urls";
import { applyCheckboxField, applyRangeField } from "./utils";

interface UseOptimizationHandlersParams {
  optimizationConfig: IOptimizationConfig;
  optimizationConfigCallBack: IOptimizationConfigCallBack;
  roadwayConfig: IRoadwayConfig;
  luminaireLayoutConfig: ILuminaireLayoutConfig;
}

export function useOptimizationHandlers({
  optimizationConfig,
  optimizationConfigCallBack,
  roadwayConfig,
  luminaireLayoutConfig,
}: UseOptimizationHandlersParams) {
  useEffect(() => {
    getURL();
    setFromURLObject(optimizationConfig); //not needed? should be stateful
    setFromURLObject(roadwayConfig);
    setFromURLObject(luminaireLayoutConfig);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const maintenanceFactorHandler = useCallback(
    (_name: string, data: number) => {
      const updated = { ...optimizationConfig, maintenanceFactor: data };
      setObjectURL(updated);
      optimizationConfigCallBack(updated);
    },
    [optimizationConfig, optimizationConfigCallBack],
  );

  const checkboxHandler = useCallback(
    (name: string, data: boolean) => {
      const updated = applyCheckboxField(optimizationConfig, name, data);
      if (!updated) return;
      setObjectURL(updated);
      optimizationConfigCallBack(updated);
    },
    [optimizationConfig, optimizationConfigCallBack],
  );

  const radioButtonHandler = useCallback(
    (data: OptimizationTypeEnum) => {
      const updated = { ...optimizationConfig, optimizationType: data };
      setObjectURL(updated);
      optimizationConfigCallBack(updated);
    },
    [optimizationConfig, optimizationConfigCallBack],
  );

  const selectWithStepsHandler = useCallback(
    (name: string, data: RangeWithStepOrNumber) => {
      const updated = applyRangeField(optimizationConfig, name, data);
      if (!updated) return;
      setObjectURL(updated);
      optimizationConfigCallBack(updated);
    },
    [optimizationConfig, optimizationConfigCallBack],
  );

  return { maintenanceFactorHandler, checkboxHandler, radioButtonHandler, selectWithStepsHandler };
}
